import {Component, Inject, isDevMode} from '@angular/core';
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Units} from "../../../interfaces/Units";
import {CentreService} from "../../../services/centre.service";
import {MatSelectChange} from "@angular/material/select";
import {Observable, firstValueFrom} from "rxjs";
import {UnitService} from "../../../services/unit.service";
import {Centre} from "../../../interfaces/Centres";
import {FullChild} from "../../../interfaces/FullChild";
import {ChildService} from "../../child/child.service";
import {LogService} from "../../../services/log.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {environment} from "../../../../environments/environment";

@Component({
    selector: 'app-unit-transfer',
    templateUrl: './unit-transfer.component.html',
    styleUrls: ['./unit-transfer.component.scss']
})
export class UnitTransferComponent {
    // Expose dev/prod info for the template banner
    readonly isDevMode = isDevMode();
    readonly activeEnv = isDevMode() ? environment.testMode : environment.productionMode;

    type: 'Unit Transfer' | 'Centre Transfer' = 'Unit Transfer';
    centre: Observable<Centre[]>;
    fromChild: any;
    toChild: any;
    mChildAData!: FullChild;
    mChildBData!: FullChild;
    fromCentre: Centre | undefined;
    toCentre: Centre | undefined;
    unitsArray: Units[] = [];
    unitsArray2: Units[] = [];
    toChildExists: boolean | undefined = undefined;
    isSubmitting = false;

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                private mCentreService: CentreService,
                private readonly unitService: UnitService,
                private readonly mChildService: ChildService,
                private mLogService: LogService,
                private mSnackbar: MatSnackBar) {
        this.centre = mCentreService.getAllCentres();
    }


async onCenterSelected(event$: MatSelectChange) {
    this.fromCentre = event$.value;
    this.unitsArray = [];
    this.unitsArray2 = [];
    this.fromChild = undefined;
    this.toChild = undefined;
    this.mChildAData = undefined as any;
    this.mChildBData = undefined as any;
    this.toChildExists = undefined;

    const units = await firstValueFrom(this.unitService.getUnit(event$.value.centreCode));
    units.forEach(unit => {
      if (typeof unit === 'object' && unit !== null && 'key' in unit && 'centreCode' in unit) {
        this.unitsArray.push(unit as Units);
        if (this.type === 'Unit Transfer') this.unitsArray2.push(unit as Units);
      }
    });
  }

  async onCenterSelected2(event$: MatSelectChange) {
    this.toCentre = event$.value;
    this.unitsArray2 = [];
    this.toChild = undefined;
    this.mChildBData = undefined as any;
    this.toChildExists = undefined;

    const units = await firstValueFrom(this.unitService.getUnit(event$.value.centreCode));
    units.forEach(unit => {
      if (typeof unit === 'object' && unit !== null && 'key' in unit && 'centreCode' in unit) {
        this.unitsArray2.push(unit as Units);
      }
    });
  }


  async submit() {
    if (this.isSubmitting) return;

    // Guard: same unit selected for From and To
    if (this.fromChild?.key === this.toChild?.key && this.fromCentre?.centreCode === (this.toCentre?.centreCode ?? this.fromCentre?.centreCode)) {
      this.mSnackbar.open('From and To units must be different', '', { duration: 3000, panelClass: 'error' });
      return;
    }

    this.isSubmitting = true;
    try {
      if (this.type === 'Unit Transfer') {
        if (this.toChildExists) {
          await this.swapUnits();
          this.mLogService.addLog({
            date: new Date().getTime(),
            section: 'Unit Transfer',
            action: 'Swap Units',
            description: `Child ${this.mChildAData.childCode} swapped unit with child ${this.mChildBData.childCode} (unit ${this.fromChild?.key} ↔ ${this.toChild?.key})`,
            currentIp: localStorage.getItem('currentip')!
          });
        } else {
          await this.unitService.transferToEmptyUnit(this.fromChild, this.toChild, this.mChildAData);
          this.mLogService.addLog({
            date: new Date().getTime(),
            section: 'Unit Transfer',
            action: 'Transfer to Empty Unit',
            description: `Child ${this.mChildAData.childCode} transferred to empty unit ${this.toChild?.key}`,
            currentIp: localStorage.getItem('currentip')!
          });
        }
      } else if (this.type === 'Centre Transfer') {
        if (this.toChildExists) {
          await this.unitService.centreTransfer(this.fromChild, this.toChild, this.mChildAData, this.mChildBData);
          this.mLogService.addLog({
            date: new Date().getTime(),
            section: 'Unit Transfer',
            action: 'Centre Transfer (Swap)',
            description: `Child ${this.mChildAData.childCode} swapped centre with child ${this.mChildBData.childCode} (${this.fromCentre?.centreName} ↔ ${this.toCentre?.centreName})`,
            currentIp: localStorage.getItem('currentip')!
          });
        } else {
          await this.unitService.centreTransferToEmpty(this.fromChild, this.toChild, this.mChildAData);
          this.mLogService.addLog({
            date: new Date().getTime(),
            section: 'Unit Transfer',
            action: 'Centre Transfer (To Vacant)',
            description: `Child ${this.mChildAData.childCode} transferred from ${this.fromCentre?.centreName} to vacant unit ${this.toChild?.key} at ${this.toCentre?.centreName}`,
            currentIp: localStorage.getItem('currentip')!
          });
        }
      }

      this.mSnackbar.open('Transfer completed successfully', '', { duration: 3000 });
      this.resetForm();
    } catch (err) {
      console.error('Transfer failed:', err);
      this.mSnackbar.open(this.unitService.errorMessage(err, 'complete the transfer'), 'Close', { duration: 8000, panelClass: 'error' });
    } finally {
      this.isSubmitting = false;
    }
  }

  resetForm() {
    this.fromChild = undefined;
    this.toChild = undefined;
    this.fromCentre = undefined;
    this.toCentre = undefined;
    this.unitsArray = [];
    this.unitsArray2 = [];
    this.mChildAData = undefined as any;
    this.mChildBData = undefined as any;
    this.toChildExists = undefined;
  }


    fetchChildDataFromUnitA(_$event: MatSelectChange) {
        this.mChildAData = undefined as any;
        this.mChildBData = undefined as any;
        this.toChildExists = undefined;
        this.toChild = undefined;

        if (!this.fromChild?.allotedTo || this.fromChild.allotedTo === 'NA') return;

        this.mChildService.getChildByCode(this.fromChild.allotedTo).then(res => {
            this.mChildAData = res?.data() as FullChild;
        });
    }

    fetchChildDataFromUnitB(_$event: MatSelectChange) {
        this.mChildBData = undefined as any;
        this.toChildExists = undefined;

        if (this.toChild.allotedTo === 'NA') {
            this.toChildExists = false;
            return;
        }

        this.mChildService.getChildByCode(this.toChild.allotedTo).then(res => {
            this.mChildBData = res?.data() as FullChild;
            this.toChildExists = true;
        });
    }

    private swapUnits() {
        return this.unitService.swapUnits(this.fromCentre!, this.fromChild, this.toChild, this.mChildAData, this.mChildBData);
    }


}
